import { render } from "./ComprehensiveAnalysis.vue?vue&type=template&id=32c01f5f&scoped=true"
import script from "./ComprehensiveAnalysis.vue?vue&type=script&lang=js"
export * from "./ComprehensiveAnalysis.vue?vue&type=script&lang=js"

import "./ComprehensiveAnalysis.vue?vue&type=style&index=0&id=32c01f5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c01f5f"]])

export default __exports__